import type { ComponentProps } from "react"
import { ToggleGroupItem as ToggleGroupItemBase } from "@/v2-ui/toggleGroup/base/ToggleGroupBase"

export type ToggleGroupItemProps = ComponentProps<typeof ToggleGroupItemBase>

function ToggleGroupItem(props: ToggleGroupItemProps) {
  const { className, ...toogleGroupItemBaseProps } = props
  return (
    <ToggleGroupItemBase className={className} {...toogleGroupItemBaseProps} />
  )
}

export default ToggleGroupItem
